module.exports = __webpack_public_path__ + "img/dk.153df901.svg";